import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "smilingFaceFilled"
const SmilingFaceFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M5.717 13.343C6.212 14.603 7.074 15.685 8.191 16.448S10.63 17.621 11.982 17.625C13.335 17.628 14.658 17.225 15.78 16.468 16.9 15.71 17.77 14.633 18.27 13.376L16.878 12.82C16.487 13.798 15.81 14.636 14.939 15.225S13.04 16.128 11.986 16.125 9.906 15.803 9.037 15.21C8.17 14.616 7.498 13.774 7.113 12.795zM7.511 8.25C6.965 8.247 6.436 8.444 6.024 8.802 5.612 9.159 5.344 9.655 5.271 10.196L6.014 10.297 6.757 10.4C6.78 10.219 6.87 10.053 7.007 9.934 7.146 9.814 7.323 9.749 7.505 9.75 7.686 9.75 7.86 9.818 7.997 9.938S8.221 10.225 8.244 10.405L9.732 10.218C9.664 9.675 9.4 9.177 8.992 8.815 8.581 8.454 8.056 8.253 7.51 8.25M16.511 8.25C15.965 8.247 15.436 8.444 15.024 8.802 14.612 9.159 14.344 9.655 14.271 10.196L15.014 10.297 15.757 10.4C15.78 10.219 15.87 10.053 16.007 9.934 16.146 9.814 16.323 9.749 16.505 9.75 16.685 9.75 16.86 9.818 16.997 9.938 17.134 10.058 17.221 10.225 17.244 10.405L18.732 10.218C18.664 9.675 18.4 9.177 17.992 8.815 17.581 8.454 17.056 8.253 16.51 8.25"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SmilingFaceFilledIcon
